<template>
    <!--<div>-->
        <image-wrapper v-if="componentType === 'image'"  v-bind="imageWrapperProps"  class="learnworlds-AR-16-9 learnworlds-bg-default js-change-image-node js-screen-image-wrapper">
            <!--<slot v-for="(_, name) in $slots" :name="name"/>-->
            <!--<slot slot="overlay" name="overlay"> </slot>-->
            <slot slot="caption" name="caption"> </slot>
        </image-wrapper>

        <video-wrapper v-else-if="componentType === 'video'" v-bind="videoWrapperProps" class="learnworlds-AR-16-9 learnworlds-video-iframe-wrapper js-video-wrapper js-screen-video-wrapper">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        </video-wrapper>

        <embed-wrapper v-else-if="componentType === 'embed'" v-bind="embedWrapperProps" class="learnworlds-AR-16-9 js-embed-wrapper js-screen-embed-wrapper">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
        </embed-wrapper>
    <!--</div>-->
</template>
<script>

    import PageComponentMixin from '../mixins/PageComponentMixin';
    import Video from './Video.vue';
    import Embed from './Embed.vue';
    import Image from './Image.vue';


    const ImageConfig = {
        src: "https://www.learnworlds.com/app/uploads/2015/12/metadata-img.png",
        type: "background-image"
    }

    const VideoConfig = {
        provider : "vimeo",
        videoId : "335295041",
        videoParams: {
            autoplay: true,
            loop: true,
            muted: true,
            popup: true
        }
    }

    const EmbedConfig = {

    }

    const schema = {
        type: 'media',
        config: {
            //TODO REPLACE DYNAMICALLY
            componentType : "image",
            imageData: ImageConfig,
            videoData: VideoConfig,
            embedData: EmbedConfig
        },

    }

    export default {
        name: 'Media',
        schema,
        mixins : [PageComponentMixin],
        computed : {
            componentType () {
                return this.$componentData.componentType;
            },
            videoWrapperProps () {
                return this.$componentData.videoData;
            },
            imageWrapperProps () {                
                return this.$componentData.imageData;
            },
            embedWrapperProps () {                
                return this.$componentData.embedData;
            },
            
        },
        methods : {
            logA () {console.log("in media image wrapper click")},
            logB () {console.log("in media overlay slot click")},
            logC () {console.log("in media caption slot click")},
        },
        components : {
            "image-wrapper": Image,
            "video-wrapper": Video,
            "embed-wrapper": Embed
        }
    }
</script>